<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs settings-amenities">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsParcelsService.showDetailedView"
         [ngStyle]="{width: settingsParcelsService.showDetailedView ? 'calc(100% - 520px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-12">
                    <filter [tabHeading]="'Corporation'" [buildings]="settingsParcelsService.buildingsForRead"></filter>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allSettingsParcels'" [ngClass]="{'sk-loading': settingsParcelsService.spinnerShow}">
                    <settings-parcels-list></settings-parcels-list>
                    <spinner [spinnerShow]="settingsParcelsService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="settingsParcelsService.corporations.data.length > 0 && urlService.queryParams['page']"
                            [total]="settingsParcelsService.corporations.total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar"
         *ngIf="settingsParcelsService.showDetailedView">
        <settings-parcels-detailed-view></settings-parcels-detailed-view>
    </div>
</div>
<package-type-modal *ngIf="settingsParcelsService.isPackageTypeModalShow"></package-type-modal>
<courier-type-modal *ngIf="settingsParcelsService.isCouriersModalShow"></courier-type-modal>
<notification-modal *ngIf="settingsParcelsService.isNotificationModalShow"></notification-modal>
<sms-notification-modal *ngIf="settingsParcelsService.isSmsNotificationModalShow"></sms-notification-modal>
<reminder-text-modal *ngIf="settingsParcelsService.isShowReminderTextModal"></reminder-text-modal>
<sms-reminder-text-modal *ngIf="settingsParcelsService.isShowSmsReminderTextModal"></sms-reminder-text-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/settings-parcels.component.html